/**
 * @file 英文文案
 * @author  fangsimin
 * @date    2019-01-02 09:55:16
 * @last Modified by    fangsimin
 * @last Modified time  2020-02-09 21:30:57
 */

import enLocale from 'element-ui/lib/locale/lang/en';
import msnlang from './msn/en'; // msn模块的语言
import cmplang from './cmp/en'; // msn模块的语言

const en = {
    message: {
        hello: 'hello, world'
    },
    ...enLocale,
    msn: msnlang,
    cmp: cmplang
};

export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js